import React from 'react';
import { arrayOf, bool, func, number, oneOfType, shape, string } from 'prop-types';
import CompensationSummaryCard from '../CompensationSummaryCard/CompensationSummaryCard';
import InternalDataColumn from './InternalDataColumn/InternalDataColumn';

import './InternalData.scss';

class InternalData extends React.Component {
  static propTypes = {
    checked: bool,
    data: arrayOf(
      shape({
        key: string,
        value: oneOfType([number, string])
      })
    ),
    onToggle: func,
    replacementTokens: arrayOf(
      shape({
        token: string,
        value: string
      })
    ),
    isConfigVisible: bool,
    hasData: bool
  };

  getDataColumns = () => {
    const { data, replacementTokens } = this.props;
    const clonedData = [...data];
    const dataColumns = [];
    const rowCount = data.length / 3;
    const remainder = data.length % 3;
    let numberOfRows = 1;

    for (let i = 0; i < clonedData.length; i = 0) {
      const increment = numberOfRows <= remainder ? rowCount + 1 : rowCount;
      const dataRow = clonedData.splice(i, increment);

      dataColumns.push(
        <InternalDataColumn data={dataRow} key={`column-${numberOfRows}`} replacementTokens={replacementTokens} />
      );

      numberOfRows += 1;
    }

    return dataColumns;
  };

  render() {
    const { checked, onToggle, isConfigVisible, hasData } = this.props;

    return (
      <CompensationSummaryCard
        cardTitle="Internal Data"
        checked={checked}
        onToggle={onToggle}
        isConfigVisible={isConfigVisible}
        hasData={hasData}
      >
        {hasData ? (
          <div className="comp-sum__internal-data">{this.getDataColumns()}</div>
        ) : (
          <div className="comp-sum-card__empty-title">No Internal Data Available</div>
        )}
      </CompensationSummaryCard>
    );
  }
}

export default InternalData;
